import React from "react";
import emptyImg from "../../../assets/img/landing/icon/emptyFile.png";
import "./EmptyPage.scss";

const EmptyPage = ({ text = "اطلاعاتی برای نمایش وجود ندارد" }) => {
  return (
    <div className="empty-page-wrapper">
      <img src={emptyImg} alt="empty page" className="empty-page-image" />
      <p className="empty-page-text">{text}</p>
    </div>
  );
};

export default EmptyPage;